import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { ValidationService } from '../../../shared/providers/validation.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SharedService } from '../../../shared/providers/shared.service';
import { Params, ActivatedRoute } from '@angular/router';
import { StockInfoComponent } from './stock-info/stock-info.component';

@Component({
  selector: 'app-financial-news',
  templateUrl: './financial-news.component.html',
  styleUrls: ['./financial-news.component.css']
})
export class FinancialNewsComponent implements OnInit {

  constructor(private propertyListing: PropertyListingService, protected activatedRoute: ActivatedRoute, private shared: SharedService, private modalService: BsModalService, private Validation: ValidationService) { }
  newsList: any;
  generalNewsList: any;
  user: any;
  showNewsFeed = false;
  tickerSymbol = [];
  showMarketValue = false;
  public currentsourcepage: string = '';
  selectedTicker: string = '';
  @Input() hideStocInfo = false;
  @Input() SoucePage: string = '';

  tickersAvailable = false;
  @ViewChild(StockInfoComponent) child: StockInfoComponent;
  @Input() sellerId = 0;
  @Input() prevPage = null;
  slideConfig = {
    "slidesToShow": 1, "slidesToScroll": 1, "speed": 800, "centerMode": false, "dots": true, "variableWidth": true, "autoplay": false, "autoplaySpeed": 2000, "infinite": true,
  };
  afterChange(e) {

  }

  ngOnInit() {
    if (this.SoucePage != null) {
      this.currentsourcepage = this.SoucePage;
    }
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params["seller"] != null) {
        this.sellerId = params["seller"];
      }
      if (params["ticker"] != null) {
        this.selectedTicker = params["ticker"];
      }
    });

    //this.shared.financialSummaryChange.subscribe(res => {

    //    if (res > 0 && res != undefined) {
    //        this.loadData(res);
    //    }
    //});
    this.loadData();
  }
  loadData(value = 0) {
    this.propertyListing.GetDefaultTickers(this.sellerId).subscribe(response => {
      let tickerSymbol = response;
      this.tickerSymbol = response;
      this.showMarketValue = true;
      let tickerString = tickerSymbol.length > 0 ? tickerSymbol.map(o => o.Symbol).join(',') : "";
      if (this.selectedTicker != null && this.selectedTicker != '' && this.selectedTicker != undefined) {
        tickerString = this.selectedTicker;
      }
      if (tickerString.trim().length > 0) {
        this.tickersAvailable = true;
        var count = this.hideStocInfo ? 50 : 9;
        this.propertyListing.GetStockNews(tickerString, count).subscribe(res => {

          if (this.hideStocInfo) {
            this.propertyListing.GetStockGeneralNews(count).subscribe(result => {
              var tickerNews = res["data"];
              var generalNews = result["data"];
              this.generalNewsList = tickerNews.concat(generalNews).sort();
              this.newsList = this.generalNewsList.slice(0, 12);
              this.showNewsFeed = true;
            });
          }
          else {
            this.newsList = res["data"];
            this.showNewsFeed = true;
          }
        });

      }
      else {
        this.tickersAvailable = false;
      }
    });
  }
  viewMore() {

    var startIndex = this.newsList.length - 1;
    var data = this.generalNewsList.slice(startIndex, startIndex + 12);
    this.newsList = this.newsList.concat(data);
  }
  viewLess() {

    var startIndex = this.newsList.length - 1;
    if (startIndex > 11) {
      this.newsList = this.newsList.splice(startIndex - 12, 12);
    }
  }
  getFirstHalf() {
    return this.newsList.slice(0, 5);
  }

  getSecondHalf() {
    return this.newsList.slice(5, this.newsList.length);
  }

  getNewsTime(newsDate) {
    newsDate = this.Validation.convertUTCDateToLocalDate(newsDate);
    let minutes = this.Validation.getMinutesBetweenDates(newsDate, this.Validation.convertUTCDateToLocalDate(new Date()));
    if (minutes < 2) {
      return '1 minute ago';
    }
    else if (minutes < 60) {
      return minutes + ' minutes ago';
    }
    else if (minutes => 60 && minutes < 1400) {
      return Math.round(minutes / 60) + (Math.round(minutes / 60) > 1 ? ' hours' : ' hour') + ' ago';
    }
    else {
      return newsDate;
    }
  }
  modalRefAddTicker: BsModalRef;
  openAddTicker(template: TemplateRef<any>, classes: any) {
    this.modalRefAddTicker = this.modalService.show(template, { class: classes });
  }
  closeAddTickerModal() {
    this.showMarketValue = false;
    this.ngOnInit();
    setTimeout(() => {
      //// this.child.stockInfo = [];
      this.child.ngOnInit();
    }, 1000);
  }
  tickerChanges(event) {
    this.ngOnInit();
  }
}
